/**
 * Mindarc Out of Stock Vue Component for my Acount page
 * This component display customer's out of stock products in the account page
 * ------------------------------------------------------------------------------
 * Template in snippets/notify-me.liquid
 *
 */
import $ from 'jquery';
import Vue from 'vue';
import axios from 'axios';

const apiEndpoints = {
    dev: 'https://shopifyoutofstockapp-dev.testarc.com.au',
    prod: 'https://shopifyoutofstockapp.testarc.com.au'
};

function getApiEndpoint() {
    return window.location.hostname == 'white-fox-boutique-develop.myshopify.com' ? apiEndpoints.dev : apiEndpoints.prod;
}

Vue.component('notify-me', {
    props: ['email', 'appAddToCart'],
    data() {
        return {
            isLoading: true,
            thisProducts: [],
            isSubmitting: false,
        }
    },
    
    methods: {
        getProductURL(handle, variant){
            return "/products/"+handle+"?variant="+variant;
        },

        handleAddToCart(variant){
          
                this.isSubmitting = true;
                this.appAddToCart(variant).then((response) => {
                    console.log('success');
                    this.isSubmitting = false;
                    this.isAddtocartConfirmationOpen = true;

                }).catch((error) => {
                    console.log('error', error);
                    this.isSubmitting = false;
                    alert('Cannot reach the server at this time, please try again later.');
                });
           
        },

        cancelOutOfStock(sub_id){

            let subId = sub_id;

            axios.post(`${getApiEndpoint()}/subscriptions/api/cancel?shop=${Shopify.shop}`, { id: subId})
                    .then(response => {
                        // Remove item from font-end
                        this.thisProducts.forEach(product => {
                            if(product.sub_id == subId){
                               let i = this.thisProducts.indexOf(product);
                               this.$delete(this.thisProducts, i);
                            }
                        });
                        console.log('Product removed from out of stock');
                    })
                    .catch(error => {
                        console.log("Remove out of stock Error : ", error)
                    });
        },

   
    },

    created(){
        
        // GET out of stock notification for user
        axios.get(`${getApiEndpoint()}/subscriptions/api/get?shop=${Shopify.shop}&email=${this.email}`)
        .then(response => {
            this.thisProducts = response.data.data;
            this.isLoading = false;
        })
        .catch(error => {
            console.log(error);
        });
    },

    mounted(){


    }
});
